// extracted by mini-css-extract-plugin
export default {"cls1":"AcademiaIcon-cls1_KCh","cls2":"AcademiaIcon-cls2_igS AcademiaIcon-cls1_KCh"};